import { type GlobalDictionary } from "./generated-types.ts";

const dictionaryString = document.head.querySelector<HTMLScriptElement>("#global-dictionary")?.innerHTML || "{}";

export const globalDictionary = JSON.parse(dictionaryString) as GlobalDictionary;